// extracted by mini-css-extract-plugin
export default {"advertisingContainer":"Advertising_advertisingContainer__gli+K"};